var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "call-logs-quick-filter m-t-10" }, [
    _c(
      "div",
      {
        staticClass:
          "reporting-call-logs-header reporting-settings-v2 p-b-0 m-b-20"
      },
      [
        _c("div", { staticClass: "reporting-call-logs-header__title" }, [
          _vm._v("\n      Target Dial Insights\n    ")
        ]),
        _vm._v(" "),
        _c("SearchableDropdown", {
          staticClass:
            "reporting-settings-v2__timezone-selector m-b-10 m-l-auto",
          attrs: {
            rules: "required",
            config: _vm.timezoneDropdownOptions,
            clearable: false
          },
          model: {
            value: _vm.tempTimezoneId,
            callback: function($$v) {
              _vm.tempTimezoneId = $$v
            },
            expression: "tempTimezoneId"
          }
        }),
        _vm._v(" "),
        _c("DateRangePicker", {
          staticClass: "m-b-10 m-l-10",
          attrs: {
            "date-range-button-class": "reporting-settings-v2__date-picker btn",
            "date-range": _vm.timeRange,
            options: _vm.dateRangeConfig,
            "time-zone-id": _vm.translatedTimeZoneId
          },
          on: { onDateRangeChange: _vm.onDateRangeChange }
        }),
        _vm._v(" "),
        _vm.canExport
          ? _c(
              "button",
              {
                staticClass: "btn m-b-10 m-l-10",
                attrs: {
                  disabled:
                    _vm.eventInsightsData.allRecords.length < 1 ||
                    _vm.showLoader
                },
                on: { click: _vm.exportExcel }
              },
              [
                _c("span", {
                  staticClass: "fa fa-download p-0 m-l-4 visible-xs-inline",
                  class: { invisible: _vm.showLoader }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "hidden-xs" }, [
                  _vm._v(_vm._s(_vm.$t("EXPORT_CSV")))
                ])
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.showPartialDataSetMessage
          ? _c(
              "div",
              {
                staticClass:
                  "reporting-grid-notification--partial bg-info m-t-2",
                on: { click: _vm.hidePartialDatasetNotification }
              },
              [
                _c("i", { staticClass: "fa fa-times pull-right m-t-3 m-l-5" }),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-info m-t-3 m-r-5" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PARTIAL_DATA_SET_DATE_RANGE_MESSAGE",
                      expression: "'PARTIAL_DATA_SET_DATE_RANGE_MESSAGE'"
                    }
                  ]
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("AgGridVue", {
          staticClass:
            "ag-grid--custom ag-grid--call-logs ag-grid--call-logs-quick-insights ag-grid--dial-level-insights ag-theme-balham-dark",
          attrs: {
            "row-data": _vm.eventInsightsData.allRecords,
            "default-col-def": _vm.defaultColDef,
            "column-defs": _vm.columnDefs,
            "column-types": _vm.colTypes,
            "suppress-context-menu": true,
            "suppress-movable-columns": true,
            "overlay-no-rows-template": _vm.overlayNoRowsTemplate,
            "suppress-animation-frame": true,
            "suppress-set-column-state-events": true,
            "suppress-property-names-check": true,
            "dom-layout": "autoHeight"
          },
          on: { "grid-ready": _vm.onGridReady }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }